module.exports = __webpack_public_path__ + "images/arrows---09b24f1a73b9eeb5cc62db7ec0b60bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/style/img/arrows.png
// module id = 396
// module chunks = 0